// @flow
import { Observable, of } from 'rxjs';
import { map, catchError, mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { fetchDisbursementInfoApi } from './api';
import { setNewAlert } from '../../../alert/duck';
import { confirmArrivalError } from '../received/duck';

import type { HTTPError } from '../../../../error';

import type { Payout } from '../../../../entities';

export type CompletedAction = {
  +type: string;
  +disbursementInfo?: Payout;
  +error?: HTTPError;
};

export type CompletedState = {
  disbursementInfo?: Payout;
  isFetchingDisbursement?: boolean;
  error?: HTTPError;
};

// Actions
const COMPLETED_FETCH_DISBURSEMENT_REQUEST = 'COMPLETED_FETCH_DISBURSEMENT_REQUEST';
const COMPLETED_FETCH_DISBURSEMENT_SUCCESS = 'COMPLETED_FETCH_DISBURSEMENT_SUCCESS';
const COMPLETED_FETCH_DISBURSEMENT_ERROR = 'COMPLETED_FETCH_DISBURSEMENT_ERROR';

// Action creators
export function fetchDisbursementInfo(): CompletedAction {
  return {
    type: COMPLETED_FETCH_DISBURSEMENT_REQUEST,
  }
}

export function fetchDisbursementInfoSuccess(disbursementInfo: Payout): CompletedAction {
  return {
    type: COMPLETED_FETCH_DISBURSEMENT_SUCCESS,
    disbursementInfo,
  }
}

export function fetchDisbursementInfoError(error: HTTPError): CompletedAction {
  return {
    type: COMPLETED_FETCH_DISBURSEMENT_ERROR,
    error,
  }
}

export const actions = {
  COMPLETED_FETCH_DISBURSEMENT_REQUEST,
  COMPLETED_FETCH_DISBURSEMENT_SUCCESS,
  COMPLETED_FETCH_DISBURSEMENT_ERROR,
  fetchDisbursementInfo,
  fetchDisbursementInfoSuccess,
  fetchDisbursementInfoError,
};

export const initialState: CompletedState = {};

// Reducer
export default function reducer(state: CompletedState = initialState,
                                action: CompletedAction): CompletedState {
  switch (action.type) {
    case COMPLETED_FETCH_DISBURSEMENT_REQUEST:
      return {
        isFetchingDisbursement: true,
      };
    case COMPLETED_FETCH_DISBURSEMENT_SUCCESS:
      return {
        disbursementInfo: action.disbursementInfo
      };
    case COMPLETED_FETCH_DISBURSEMENT_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function fetchDisbursementInfoEpic(action$: Observable<CompletedAction>): Observable<CompletedAction> {
  return action$.pipe(
    ofType(COMPLETED_FETCH_DISBURSEMENT_REQUEST),
    mergeMap(() => fetchDisbursementInfoApi()
      .pipe(
        map(fetchDisbursementInfoSuccess),
        catchError((e: HTTPError) => {
          if (Math.round(e.code / 100) === 5) {
            return of(confirmArrivalError(e),
              setNewAlert('order', 'error', undefined, 'httpErrors.fetch.500'),
            );
          } else if (e.code === 400) {
            return of(confirmArrivalError(e),
              setNewAlert('order', 'error', undefined, 'httpErrors.fetch.400'),
            );
          }
          return of(fetchDisbursementInfoError(e))
        }))
    ));
}



// WEBPACK FOOTER //
// ./src/modules/order/Sale/completed/duck.js